export const name = 'loginSocialBar' as const
